import React, { useState } from "react";
import { PageHeader, Space, Col, Card, Form, Button, message } from "antd";
import { useHistory } from "react-router-dom";
import DatepickerRanger from "../components/toolbox/DatepickerRanger";
import strings from "../utils/Localization";
import CariKartSelectOption from "../components/toolbox/CariKartSelectOption";
import DovizSelectOption from "../components/toolbox/DovizSelectOption";
import FaturaTipSelectOption from "../components/toolbox/FaturaTipSelectOption";
import OdemeSekliSelectOption from "../components/toolbox/OdemeSekliSelectOption";
import { api } from "../helpers/ApiHelper";
import moment from "moment";
import useVarsayilanDeger from "../hooks/useVarsayilanDeger";

function FaturaRapor() {
  const [fetchLoading, setFetchLoading] = useState(false);
  const history = useHistory();
  const { faturaRapor: localization } = strings;
  const { getDefaultSetting } = useVarsayilanDeger();

  const onFinish = async (values) => {
    try {
      const { tarih, cariKartId, dovizId, faturaTip, odemeSekli } = values;

      const baslangicTarihi = moment(tarih[0]).format("YYYY-MM-DD");
      const bitisTarihi = moment(tarih[1]).format("YYYY-MM-DD");

      setFetchLoading(true);
      const response = await api.post(
        "/rapordosya/fatura",
        {
          BaslangicTarih: `${baslangicTarihi} 00:00:00`,
          BitisTarih: `${bitisTarihi} 23:59:59`,
          CariKartId: cariKartId === undefined ? 0 : cariKartId,
          DovizId: dovizId === undefined ? 0 : dovizId,
          FaturaTip: faturaTip === undefined ? "" : faturaTip,
          OdemeSekli: odemeSekli === undefined ? "" : odemeSekli,
          format: "pdf",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        return window.open(response.data, "_blank");
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setFetchLoading(false);
    }
  };

  return (
    <Space style={{ width: "100%" }} size="middle" direction="vertical">
      <PageHeader
        title={localization.baslik}
        onBack={() => history.goBack()}
        ghost={false}
      />
      <Col xxl={8} xl={12} lg={24} md={24} sm={24} xs={24}>
        <Card>
          <Form
            onFinish={onFinish}
            layout="vertical"
            initialValues={{
              tarih: [moment().add("months", -12), moment()],
              dovizId: getDefaultSetting("doviz"),
            }}
          >
            <DatepickerRanger
              formName="tarih"
              formLabel={localization.tarihSeciniz}
              required
            />
            <CariKartSelectOption formItemName="cariKartId" allowClear />
            <DovizSelectOption formItemName="dovizId" allowClear />
            <FaturaTipSelectOption formItemName="faturaTip" allowClear />
            <OdemeSekliSelectOption
              formItemName="odemeSekli"
              formItemLabel={localization.odemeSekliSeciniz}
              allowClear
            />
            <Form.Item noStyle>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                style={{ float: "right" }}
                loading={fetchLoading}
              >
                {localization.faturaRaporuAl}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Space>
  );
}

export default FaturaRapor;
